import useMemberJoinAlerts from './useMemberJoinAlerts';

export default useMemberJoinAlerts;
